<header nx-header>
    <nx-header-row>
      <nx-header-brand>
        <nx-link>
          <a href="#">
            <figure nxFigure>
              <img
                src="assets/APlogo.png"
                alt="Allianz Global Brand Logo"
                role="none"
                style="width: 175px"
              />
            </figure>
          </a>
        </nx-link>
      </nx-header-brand>
    </nx-header-row>
</header>
<div>
    <nx-small-stage>
        <nx-card style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;">
            <nx-card-header>
              <h1 nxHeadline style="text-align: center;color: green;" class="nx-font-weight-bold nx-margin-bottom-m"  *ngIf="transactionStatus">Thank You!</h1>
              <h1 nxHeadline style="text-align: center;color:red;" class="nx-font-weight-bold nx-margin-bottom-m" *ngIf="!transactionStatus">Payment Failed</h1>
                <nx-icon *ngIf="transactionStatus" name="check-circle" size="m" style="color: green;"></nx-icon>
                <nx-icon *ngIf="!transactionStatus" name="close-circle" size="m" style="color: red;"></nx-icon>
                <h3 nxHeadline="subsection-small" class="nx-margin-bottom-2m">{{responsemessage}}</h3>
            </nx-card-header>
            <p nxHeadline="subsection-xsmall" class="nx-margin-bottom-m" *ngIf="productInfo=='Online policy transaction'">Policy txn id : {{transactionId}}</p>
            <p nxHeadline="subsection-xsmall" class="nx-margin-bottom-m" *ngIf="productInfo=='Online wallet recharge'"> Transaction Id: {{transactionId}}</p>

            <p nxHeadline="subsection-xsmall" class="nx-margin-bottom-m" *ngIf="transactionStatus && productInfo=='Online policy transaction'">Policy Number : {{policyNo}}</p>
            <div nxRow nxRowJustify="start,start,around" nxRowAlignContent="end">
              <div nxCol="12" style="text-align: center" class="nx-margin-top-xs">
                <button
                  nxButton="tertiary"
                  type="button"
                  [routerLink]="['/sellpolicy']"
                >
                  <nx-icon name="product-house" class="nx-margin-right-s"></nx-icon>Go
                  Home
                </button>
              </div>
              <div nxCol="12" style="text-align: center;">
                <button nxButton="primary" type="button" (click)="download()" *ngIf="transactionStatus  && productInfo=='Online policy transaction'">
                  <nx-icon name="pdf" class="nx-margin-right-s"></nx-icon>Download Policy
              </button>
              </div> 
            </div>
            <p nxCopytext="normal" *ngIf="transactionStatus && productInfo=='Online policy transaction'">
                * Check your mail for RSA document and invoice.
                Please contact admin if not received. Close all windows to complete process
            </p>
            <p nxCopytext="normal" *ngIf="!transactionStatus">
                * if amount is debited, Do not retry payment again.
                Please contact admin and try again.
            </p>
        </nx-card>
      <br>
      <nx-small-stage-image *ngIf="!transactionStatus" 
        nxSmallStageImageStart
        src="assets/illustrations/man_plugging_in_dishwasher.png"
      ></nx-small-stage-image>
      <nx-small-stage-image *ngIf="transactionStatus" 
        nxSmallStageImageStart
        src="assets/illustrations/Coverage-Business-Vehicles.png"
      ></nx-small-stage-image>
      <nx-small-stage-image *ngIf="transactionStatus" 
        nxSmallStageImageEnd
        src="assets/illustrations/Capital-solutions.png"
      ></nx-small-stage-image>
      <nx-small-stage-image *ngIf="!transactionStatus" 
        nxSmallStageImageEnd
        src="assets/illustrations/man_with_tablet_wondering.png"
      ></nx-small-stage-image>
      <nx-small-stage-image *ngIf="transactionStatus" 
        nxSmallStageImageBottom
        class="nx-hidden-s nx-hidden-xs"
        src="assets/illustrations/Capital-solutions.png"
      ></nx-small-stage-image>
      <nx-small-stage-image *ngIf="!transactionStatus" 
        nxSmallStageImageBottom
        class="nx-hidden-s nx-hidden-xs"
        src="assets/illustrations/man_with_tablet_wondering.png"
      ></nx-small-stage-image>
    </nx-small-stage>
  
    
    <app-footer></app-footer>
</div>